import { render, staticRenderFns } from "./detailAttribution.vue?vue&type=template&id=fc71f658&scoped=true&"
import script from "./detailAttribution.vue?vue&type=script&lang=js&"
export * from "./detailAttribution.vue?vue&type=script&lang=js&"
import style0 from "./detailAttribution.vue?vue&type=style&index=0&id=fc71f658&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!///node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc71f658",
  null
  
)

export default component.exports